export default {
  screenMaintenance: {
    notes:
      'Protocol name shown for screen maintenance activities in the activities list',
    message: 'Screen maintenance',
  },
  screenActivity: {
    initialColumn: {
      notes:
        'Title for the left panel layout column on the screen activity details page, showing the current state of the screen',
      message: 'Initial',
    },
    plannedColumn: {
      notes:
        'Title for the right panel layout column on the screen activity details page, showing the planned configuration',
      message: 'Planned',
    },
    selectionDetails: {
      header: {
        notes:
          'Header for the selection details pane on the screen activity details page',
        message: 'Selection details',
      },
    },
    newDialog: {
      header: {
        notes: 'Header in the new screen maintenance activity dialog',
        message: 'New screen activity',
      },
      name: {
        notes:
          'Label for the name input field in the new screen activity dialog',
        message: 'Name',
      },
    },
  },
};
